const getParameterByName = (name, url) => {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");

  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  const results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const getMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

export const replaceStoreLink = () => {
  const appleStoreButtons = document.querySelectorAll('[data-store="appstore"]');
  const playStoreButtons = document.querySelectorAll('[data-store="googleplay"]');

  if (
    appleStoreButtons &&
    appleStoreButtons.length &&
    getParameterByName('utm_source') &&
    getParameterByName('utm_medium') &&
    getParameterByName('utm_campaign')
  ) {
    appleStoreButtons.forEach(item => {
      item.setAttribute(
        'href',
        `https://itunes.apple.com/app/apple-store/id1444386377?pt=118071839&ct=${getParameterByName('utm_source')}_${getParameterByName('utm_medium')}_${getParameterByName('utm_campaign')}&mt=8`
      );
    });
  }

  if (playStoreButtons && playStoreButtons.length && window.location.href.split('?')[1]) {
    playStoreButtons.forEach(item => {
      const currentLink = item.getAttribute('href');
      const currentLinkWithoutQuerystring = currentLink.split('?')[0];

      item.setAttribute(
        'href',
        `${currentLinkWithoutQuerystring}?id=me.patw.f2efindjobs&referrer=${encodeURIComponent(window.location.href.split('?')[1])}`
      );
    });
  }
};

export const redirectToStore = () => {
  switch (getMobileOperatingSystem()) {
    case 'Android': {
      const currentLink = document.querySelector('[data-store="googleplay"]').getAttribute('href');
      const currentLinkWithoutQuerystring = currentLink.split('?')[0];

      if (window.location.href.split('?')[1]) {
        window.location.href = `${currentLinkWithoutQuerystring}?id=me.patw.f2efindjobs&referrer=${encodeURIComponent(window.location.href.split('?')[1])}`;
      } else {
        window.location.href = currentLink;
      }

      break;
    }

    case 'iOS': {
      if (getParameterByName('utm_source') && getParameterByName('utm_medium') && getParameterByName('utm_campaign')) {
        window.location.href = `https://itunes.apple.com/app/apple-store/id1444386377?pt=118071839&ct=${getParameterByName('utm_source')}_${getParameterByName('utm_medium')}_${getParameterByName('utm_campaign')}&mt=8`;
      } else {
        window.location.href = 'https://itunes.apple.com/tw/app/前端找工作/id1444386377?mt=8';
      }

      break;
    }
  }
};



// WEBPACK FOOTER //
// ./src/helpers/mobileRedirect.js